// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Yj-z","modalContent":"Zj-z","header":"_j-z","close":"ak-z"};